import { Lock, Storefront } from "@mui/icons-material";
import { Box, Chip, Stack } from '@mui/material';
import { Card } from "randmarcomps";
import { BadgeCheck, Earth, Mail, Phone } from 'lucide-react';
import { inject, observer } from "mobx-react";
import React from "react";
import { Reseller as ApiReseller } from "randmar-api-client";
import Reseller from "../../stores/reseller/Reseller";
import { RootStore } from '../../stores/rootStore';

interface IProps {
  store?: RootStore;
  reseller: Reseller | ApiReseller;
  applicationId?: string;
  actions?: React.ReactNode;
}

const ResellerCard: React.FC<IProps> = ({ reseller: rawReseller, applicationId, store, actions }) => {
  const { userStore } = store!;

  const isApi = 'ResellerId' in rawReseller;

  const reseller = {
    resellerId: isApi ? (rawReseller as ApiReseller).ResellerId : (rawReseller as Reseller).resellerId,
    onHold: isApi ? (rawReseller as ApiReseller).OnHold : (rawReseller as Reseller).onHold,
    publicName: isApi ? (rawReseller as ApiReseller).PublicName : (rawReseller as Reseller).publicName,
    isQualified: isApi ? !!(rawReseller as ApiReseller).Qualification : (rawReseller as Reseller).isQualified,
    name: isApi ? (rawReseller as ApiReseller).Name : (rawReseller as Reseller).name,
    city: isApi ? (rawReseller as ApiReseller).City : (rawReseller as Reseller).city,
    province: isApi ? (rawReseller as ApiReseller).Province : (rawReseller as Reseller).province,
    country: isApi ? (rawReseller as ApiReseller).Country : (rawReseller as Reseller).country,
    phone: isApi ? (rawReseller as ApiReseller).Phone : (rawReseller as Reseller).phone,
    publicEmail: isApi ? (rawReseller as ApiReseller).PublicEmail : (rawReseller as Reseller).publicEmail,
    website: isApi ? (rawReseller as ApiReseller).Website : (rawReseller as Reseller).website,
  };

  let qualification;
  if (isApi) {
    const qualifications = (rawReseller as ApiReseller).Qualifications || [];
    qualification = qualifications.find(q => q.ManufacturerId === applicationId)?.QualificationId;
  } else {
    const qualifications = (rawReseller as Reseller).qualifications || [];
    qualification = qualifications.find(q => q.manufacturerId === applicationId)?.qualificationId;
  }

  if (!userStore.isSuperAdmin() && qualification === "Suspended") qualification = "Do Not Sell";

  return (<Card className="relative">

    <Box sx={{ display: 'flex', gap: 2 }}>
      <Box sx={{ flexShrink: 0 }}>
        <img
          src={`https://api.randmar.io/v4/Partner/${reseller.resellerId || ""}/Account/Logo?height=144&width=144`}
        />
        <Chip color="primary" label={`Reseller | ${reseller.resellerId}`} deleteIcon={<Storefront />} />
      </Box>
      <Stack direction="column" alignItems="center" flexWrap="wrap" spacing={0.5} mb={0.75}>

        <div>
          {
            reseller.onHold !== 0 &&
            <Chip color="warning" label="On Hold" deleteIcon={<Lock />} />
          }
        </div>

        <div>
          <h3 style={{ fontSize: 16, fontWeight: 600 }}>{reseller.publicName}
            {reseller.isQualified && <BadgeCheck color="#8f679a" />}
          </h3>
          <h3 style={{ paddingTop: 2, fontSize: 14, fontWeight: 500, color: "#656565" }}>{reseller.name}</h3>
          <p style={{ paddingTop: 2, fontSize: 13, color: "#656565" }}>{reseller.city}, {reseller.province}, {reseller.country}</p>
        </div>


        <div>
          {
            reseller.phone &&
            <div style={{ display: "flex", alignItems: "center", gap: 8, paddingTop: 12 }}>
              <Phone size={16} color="#787878" />
              <p style={{ fontSize: 13, color: "#656565" }}>{reseller.phone}</p>
            </div>
          }
          {
            reseller.publicEmail &&
            <div style={{ display: "flex", alignItems: "center", gap: 8, paddingTop: 4 }}>
              <Mail size={16} color="#787878" />
              <p style={{ fontSize: 13, color: "#656565" }}>{reseller.publicEmail}</p>
            </div>
          }
          {
            reseller.website &&
            <div style={{ display: "flex", alignItems: "center", gap: 8, paddingTop: 4 }}>
              <Earth size={16} color="#787878" />
              <p style={{ fontSize: 13, color: "#656565" }}>{reseller.website?.replace(/^https:\/\//i, '')}</p>
            </div>
          }
        </div>
      </Stack>

    </Box>
    {actions && actions}
  </Card>);
};

export default inject('store')(observer(ResellerCard));
